import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import * as themes from "./themes/theme.json";
import { setToLocalStorage } from "./utils/storage";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#125780",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#FFF6DF",
    },

    secondaryDark: "#f1d386",
    offwhite: "#f7fafc",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const Index = () => {
  setToLocalStorage("themes", themes.default);
  return (
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  );
};
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);
